import { createServiceToken } from "@nasam/kernel";

import type { CatalogRepository } from "../features/catalog/domain";
import type {
  BranchesRepository,
  CompaniesRepository,
  DepartmentsRepository,
} from "../features/organization/domain";
import type { RolesRepository } from "../features/roles/domain";

export type {
  BranchesRepository,
  CatalogRepository,
  CompaniesRepository,
  DepartmentsRepository,
  RolesRepository,
};

export const companiesRepositoryToken = createServiceToken<CompaniesRepository>(
  "organization.companies-repository",
);

export const branchesRepositoryToken = createServiceToken<BranchesRepository>(
  "organization.branches-repository",
);

export const departmentsRepositoryToken =
  createServiceToken<DepartmentsRepository>(
    "organization.departments-repository",
  );

export const catalogRepositoryToken = createServiceToken<CatalogRepository>(
  "catalog.catalog-repository",
);

export const rolesRepositoryToken = createServiceToken<RolesRepository>(
  "roles.repository",
);
